import React from 'react';

import Seo from './Seo';

import BlockContent from '@sanity/block-content-to-react';
import { GatsbyImage } from 'gatsby-plugin-image';

import BlockLink from './blockLink';
import { Wrapper, ContentWrapper, SidebarWrapper } from './Layout';

const PreRegistration = ({ content }) => {
  const { registration } = content;
  return (
    <>
      <Seo title='Home' />
      <Wrapper>
        <ContentWrapper>
          <BlockContent blocks={registration._rawContent} />
          <BlockLink
            image={content.content[0].offsite_content.image}
            link={content.content[0].offsite_content.link}
            gatsbyLink={false}
            title={content.content[0].offsite_content.title}
            eyebrow='Recipe of the Week'
          />
        </ContentWrapper>
        <SidebarWrapper>
          <GatsbyImage
            image={registration.image.asset.gatsbyImageData}
            alt=''
          />
        </SidebarWrapper>
      </Wrapper>
    </>
  );
};

export default PreRegistration;
